//@ts-check
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getPublicBranding } from '@/api/settings.api.js';
import { APP_NAME } from '@/lib/constants.js';

/**
 * Loads public branding and syncs document title / favicon.
 */
export function useBranding() {
  const query = useQuery({
    queryKey: ['public-branding'],
    queryFn: getPublicBranding,
    staleTime: 60_000,
  });

  useEffect(() => {
    const branding = query.data;
    if (!branding) return;

    document.title = branding.siteTitle || APP_NAME;

    if (branding.faviconUrl) {
      let link = /** @type {HTMLLinkElement|null} */ (document.querySelector("link[rel='icon']"));
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = branding.faviconUrl;
    }
  }, [query.data]);

  return {
    branding: query.data ?? {
      siteTitle: APP_NAME,
      siteSubtitle: 'Warehouse dispatch video management',
      logoUrl: null,
      faviconUrl: null,
    },
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
